var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-chip"},[_c('div',{staticClass:"content"},[_vm._t("default")],2),(_vm.close)?_c('v-icon',{staticClass:"close",attrs:{"small":""},on:{"click":function($event){return _vm.$emit('input', false)}}},[_vm._v(" fas fa-times-circle theme--light ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }